/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DiscogsArtistImagesInner } from './DiscogsArtistImagesInner';
import {
    DiscogsArtistImagesInnerFromJSON,
    DiscogsArtistImagesInnerFromJSONTyped,
    DiscogsArtistImagesInnerToJSON,
} from './DiscogsArtistImagesInner';

/**
 * 
 * @export
 * @interface DiscogsArtist
 */
export interface DiscogsArtist {
    /**
     * 
     * @type {string}
     * @memberof DiscogsArtist
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsArtist
     */
    id?: string;
    /**
     * 
     * @type {Array<DiscogsArtistImagesInner>}
     * @memberof DiscogsArtist
     */
    images?: Array<DiscogsArtistImagesInner>;
}

/**
 * Check if a given object implements the DiscogsArtist interface.
 */
export function instanceOfDiscogsArtist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiscogsArtistFromJSON(json: any): DiscogsArtist {
    return DiscogsArtistFromJSONTyped(json, false);
}

export function DiscogsArtistFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsArtist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'images': !exists(json, 'images') ? undefined : ((json['images'] as Array<any>).map(DiscogsArtistImagesInnerFromJSON)),
    };
}

export function DiscogsArtistToJSON(value?: DiscogsArtist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'images': value.images === undefined ? undefined : ((value.images as Array<any>).map(DiscogsArtistImagesInnerToJSON)),
    };
}

